export default __webpack_public_path__ + "static/media/icon-standing.f8776cf5.svg";